import b64 from './base64';

const getAccessTokenFromHash = () => {
    const hash = window.location.hash;
    const result = {};
    if (hash.indexOf('access_token') < 0) return null;
    hash.slice(2).split('&').forEach((v) => {
        const s = v.split('=');
        if (s[0].indexOf('/access_token') > -1) {
            s[0] = s[0].slice(1);
        }
        result[s[0]] = s[1];
    });
    delete result.expires_in;
    delete result.state;
    return result;
};

const getAccessTokenFromLocalStorage = () => {
    const accessTokenStr = localStorage.getItem('token');
    if (accessTokenStr) {
        const accessToken = JSON.parse(accessTokenStr);
        return accessToken;
    }
    return false;
};

const initOauth = () => {
    return new Promise((resolve) => {
        let accessToken = null;
        accessToken = getAccessTokenFromHash();
        if (accessToken) {
            resolve(accessToken);
        } else {
            accessToken = getAccessTokenFromLocalStorage();
            if (accessToken) {
                resolve(accessToken);
            } else {
                resolve({});
            }
        }
    });
};

const setOauth = (app, options, accessToken) => {
    const root = app;
    const clientId = options.clientId;
    let providerValue = options.provider;
    const returnTo = options.returnTo;
    const revoke = `${providerValue}api/v1/token/${clientId}`;

    root.redirectToLogin = (append) => {
        let queryString = `response_type=token&client_id=${clientId}&redirect_uri=
        ${encodeURIComponent(returnTo)}&state=${encodeURIComponent(window.location.hash.slice(1))}`;
        queryString += append || '';
        if (window.zxyDrizzle && window.zxyDrizzle.projectConfig) {
            providerValue = window.zxyDrizzle.projectConfig.provider;
        }
        window.location = `${providerValue}#login/${b64.Base64.encode(queryString)}`;
    };

    root.redirectToRegister = () => {
        window.location = `${providerValue}/#register`;
    };
    if (accessToken.access_token) {
        root.global.OAuth = {
            token: accessToken,
            logoutUrl: `${revoke}/${accessToken.access_token}`,
            redirectUri: returnTo,
            provider: providerValue,
            tokenType: accessToken.token_type
        };
    }
};
export {
    initOauth,
    setOauth
};
